import * as yup from 'yup'

const getCombinedSchema = (options = {}) => {
  const { onlyReportVersion = false } = options

  let schema = {
    reportSelected: yup
      .string()
      .required('Você deve selecionar uma versão do relatório.'),
    consentFormId: yup.string().when('reportSelected', {
      is: 'reportByForm',
      then: yup.string().required('Formulário é obrigatório'),
      otherwise: yup.string().nullable(),
    }),
    email: yup.string().when('reportSelected', {
      is: 'reportByPeople',
      then: yup.string().required('E-mail é obrigatório').max(254),
      otherwise: yup.string().nullable(),
    }),
  }

  if (!onlyReportVersion) {
    schema = {
      ...schema,
      exportFormat: yup
        .string()
        .required('Selecione um formato de exportação.'),
      dataAction: yup.string().when('$hasCurrentVersion', {
        is: true,
        then: yup.string().required('Selecione uma ação para o relatório.'),
        otherwise: yup.string().nullable(),
      }),
    }
  }

  return yup.object().shape(schema)
}

export default getCombinedSchema
